import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { FaqSectionModel } from './models/faq-section.model';

export interface FaqSectionState extends EntityState<FaqSectionModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'faq-section', idKey: 'SectionId' })
export class FaqSectionStore extends EntityStore<FaqSectionState> {
  constructor() {
    super();
  }
}
